import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
    name: 'timeAgo',
    pure: true,
})
export class TimeAgoPipe implements PipeTransform {
    private transloco = inject(TranslocoService)
    transform(value: string | Date | null | undefined, lang?: string | null): string {
        if (value === null || value === undefined) {
            return '';
        }
        void lang;

        const date = value instanceof Date ? value : this.parseDate(value);
        const now = new Date();

        const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

        if (diffInSeconds < 60) return this.t('timeAgo.justNow');

        const minutes = Math.floor(diffInSeconds / 60);
        if (minutes < 60) {
            return this.t(minutes === 1 ? 'timeAgo.minuteAgo' : 'timeAgo.minutesAgo', {
                count: minutes
            });
        }

        const hours = Math.floor(minutes / 60);
        if (hours < 24) {
            return this.t(hours === 1 ? 'timeAgo.hourAgo' : 'timeAgo.hoursAgo', {
                count: hours
            });
        }

        const days = Math.floor(hours / 24);
        if (days < 30) {
            return this.t(days === 1 ? 'timeAgo.dayAgo' : 'timeAgo.daysAgo', {
                count: days
            });
        }

        const months = Math.floor(days / 30);
        if (months < 12) {
            return this.t(months === 1 ? 'timeAgo.monthAgo' : 'timeAgo.monthsAgo', {
                count: months
            });
        }

        const years = Math.floor(days / 365);
        return this.t(years === 1 ? 'timeAgo.yearAgo' : 'timeAgo.yearsAgo', {
            count: years
        });
    }

    private t(key: string, params?: Record<string, unknown>): string {
        return this.transloco.translate(key, params);
    }

    private parseDate(value: string): Date {
        // Handles: "04/05/2026 16:28:00"
        const [datePart, timePart] = value.split(' ');
        const [month, day, year] = datePart.split('/').map(Number);
        const [hours, minutes, seconds] = timePart.split(':').map(Number);

        return new Date(year, month - 1, day, hours, minutes, seconds);
    }
}